import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import TickerBar from "@/components/feature/TickerBar";
import Hero from "./components/Hero";
import HotTopics from "./components/HotTopics";
import CategorySection from "./components/CategorySection";
import DiscussionSection from "./components/DiscussionSection";
import VoicesSection from "./components/VoicesSection";
import FaqSection from "./components/FaqSection";
import BrandBand from "./components/BrandBand";
import { usePageMeta } from "@/hooks/usePageMeta";
import { siteFaqs } from "@/mocks/site";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "黑瓜吃料",
    alternateName: "黑瓜吃料瓜田连线讨论社区",
    url: "https://geofix.cn/",
    inLanguage: "zh-CN",
    description:
      "黑瓜吃料瓜田讨论区，汇聚围观群众观点，实时讨论当下最热瓜田话题，让你边吃边聊不落单。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://geofix.cn/?s={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑瓜吃料",
    url: "https://geofix.cn/",
    email: "hello@heiguachiliao.com",
    description: "围绕泛娱乐话题的中文讨论社区，聚合围观群众观点，实时跟进热门瓜田话题。",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: siteFaqs.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  },
];

export default function Home() {
  usePageMeta({
    title: "黑瓜吃料 | 瓜田连线吃瓜，讨论区围观群众热议",
    description:
      "黑瓜吃料瓜田讨论区，连线吃瓜群众围观热议。汇聚围观群众观点，实时讨论当下最热瓜田话题，覆盖影视剧、综艺、音乐、时尚等热门瓜田，让你边吃边聊不落单。",
    keywords: "黑瓜吃料,瓜田,讨论区,连线吃瓜,围观群众,吃瓜群众,热议",
    path: "/",
    type: "website",
    jsonLd: homeJsonLd,
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <TickerBar />
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <HotTopics />
        <CategorySection />
        <DiscussionSection />
        <VoicesSection />
        <FaqSection />
        <BrandBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}